import * as React from 'react';
import { Route } from 'react-router-dom';
import SEOTest from './pages/SEOTest';

export default [<Route exact path="/seo-test" component={SEOTest} />];
